import React from 'react';
import { Box, CloseButton, Flex, Image, Text } from '@chakra-ui/react';

import firmwareChipImg from '../../../assets/images/firmware_chip.svg';
import warningIconImg from '../../../assets/images/warning_icon.svg';

const COLOR_TOAST_BG = '#EEEEEE';
const COLOR_TOAST_CLOSE = '#333944';

type FirmwareToastVariant = 'success' | 'failure';

const VARIANT_CONFIG: Record<
  FirmwareToastVariant,
  { accent: string; icon: React.ReactElement; role: 'status' | 'alert' }
> = {
  success: {
    accent: '#42B4E6',
    icon: <Image src={firmwareChipImg} alt="" w="36px" h="36px" />,
    role: 'status',
  },
  failure: {
    accent: '#D56817',
    icon: <Image src={warningIconImg} alt="" w="30px" h="30px" data-testid="firmware-failure-toast-icon" />,
    role: 'alert',
  },
};

type FirmwareUpdatedToastProps = {
  title: string;
  description: string;
  onClose: () => void;
  variant?: FirmwareToastVariant;
};

export const FirmwareUpdatedToast = ({
  title,
  description,
  onClose,
  variant = 'success',
}: FirmwareUpdatedToastProps) => {
  const { accent, icon, role } = VARIANT_CONFIG[variant];

  return (
    <Flex
      data-testid={`firmware-${variant}-toast`}
      role={role}
      position="relative"
      w="100%"
      maxW="345px"
      minH="104px"
      mx="auto"
      bg={COLOR_TOAST_BG}
      borderRadius="2px"
      overflow="hidden"
      boxShadow="md"
    >
      <Flex w="50px" flexShrink={0} align="center" justify="center" bg={accent}>
        {icon}
      </Flex>
      <Box flex={1} minW={0} pl="18px" pr={8} py={4} alignSelf="center" color="black" fontSize="15px" lineHeight="18px">
        <Text fontWeight="bold">{title}</Text>
        <Text>{description}</Text>
      </Box>
      <CloseButton
        data-testid={`firmware-${variant}-toast-close`}
        position="absolute"
        top={1}
        right={1}
        size="sm"
        color={COLOR_TOAST_CLOSE}
        onClick={onClose}
      />
    </Flex>
  );
};
